import { LayoutFooter } from './layoutFooter'
export default LayoutFooter
